module.exports = __webpack_public_path__ + "static/media/illo-folder.789faf77.png";